import styles from './ChevronRight.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function ChevronRight({className}) {
  const classNameArray = className?.split(' ') || [];
	return (
		<svg width="100%" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={cx(['chevron-right-icon', ...classNameArray])} aria-hidden="true">
			<path d="M2 14.5 8.5 8 2 1.5" stroke="#202020" strokeWidth="2.34" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
